import { TabbedShowLayout, TabbedShowLayoutProps } from "react-admin";
import { alpha } from "@mui/material";
import { BORDER_RADIUS } from "@/constants/layout";
import { DisplayMode } from "@/types";

export const StyledTabbedShowLayout = ({ ...props }: TabbedShowLayoutProps) => {
  return (
    <TabbedShowLayout
      {...props}
      sx={[
        (theme) => ({
          "& .MuiTabs-flexContainer": {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === DisplayMode.DARK ? 0.2 : 0.1),
            borderRadius: BORDER_RADIUS.XL,
            width: "fit-content",
            padding: "4px",
          },
          "& .RaTabbedShowLayout-content": {
            padding: 0,
            paddingTop: 0,
          },
          "& .RaTabbedShowLayout-tabs": {
            borderBottom: "none",
            "& .MuiTabs-indicator": {
              display: "none",
            },
          },
          "& .MuiTab-root": {
            borderRadius: 4,
            padding: "8px 16px",
            transition: "all 0.2s",
            color: "text.primary",
            minHeight: "36px",
            "&.Mui-selected": {
              backgroundColor: "background.paper",
              color: "text.primary",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            },
          },
          "& .MuiDivider-root": {
            display: "none",
          },
          "& .MuiTabs-indicator": {
            display: "none",
          },
        }),
      ]}
    />
  );
};
